module.exports = __webpack_public_path__ + "img/webmoney.3cd6652a.png";